export enum ButtonType {
    BASIC = 'basic',
    RAISED = 'raised',
    STROKED = 'stroked',
    FLAT = 'flat',
    ICON = 'icon',
    FAB = 'fab',
    MINI_FAB = 'mini-fab'
}
